import { c as _c } from "react/compiler-runtime";
import type { ButtonHTMLAttributes, ReactElement, ReactNode } from 'react';
import { cn } from '#cn';
type CardButtonVariant = 'default' | 'danger';
const variantClasses: Record<CardButtonVariant, string> = {
  default: 'border-border text-fg hover:bg-surface-muted',
  danger: 'border-danger text-danger hover:bg-danger/5'
};
type BuildCardButtonClassNameArgs = {
  variant?: CardButtonVariant;
  className?: string;
};

/**
 * Builds the settings-card pill class string, shared so a non-`<button>`
 * control (e.g. the sign-out `next/link`) can wear the exact same styling –
 * mirrors the `buildButtonClassName` helper on the shadcn `Button`. Distinct
 * from that primary-CTA pill: this is the bordered, dark-on-white control used
 * on the settings cards.
 */
export const buildCardButtonClassName = ({
  variant = 'default',
  className
}: BuildCardButtonClassNameArgs = {}): string => cn('inline-flex items-center gap-2 rounded-full border px-5 py-2.5 text-sm font-bold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-jaaq-black disabled:opacity-40 disabled:cursor-not-allowed', variantClasses[variant], className);
type CardButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: CardButtonVariant;
  icon?: ReactNode;
};

/** A bordered pill button used on settings cards — the `default` variant for regular actions, `danger` for destructive ones. */
export const CardButton = t0 => {
  const $ = _c(16);
  let children;
  let className;
  let icon;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      variant: t1,
      icon,
      className,
      type: t2,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = icon;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[1];
    className = $[2];
    icon = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const variant = t1 === undefined ? "default" : t1;
  const type = t2 === undefined ? "button" : t2;
  let t3;
  if ($[7] !== className || $[8] !== variant) {
    t3 = buildCardButtonClassName({
      variant,
      className
    });
    $[7] = className;
    $[8] = variant;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== children || $[11] !== icon || $[12] !== props || $[13] !== t3 || $[14] !== type) {
    t4 = <button type={type} className={t3} {...props}>{icon}{children}</button>;
    $[10] = children;
    $[11] = icon;
    $[12] = props;
    $[13] = t3;
    $[14] = type;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};